"use client";
import { ROOT_URL } from "@/utils/gloableVariables";
import { usePathname } from "next/navigation";

export interface BreadcrumbStyle {
  className?: string;
  parentText?: string;
  currentText?: string;
  separatorColor?: string | null;
  disableCrumbLinks?: string[];
}

export function Breadcrumbs({ parentText = "text-[#E4E4E4]", currentText = "text-[#ffffff]", separatorColor = null, className = "my-4 max-w-section mx-auto", disableCrumbLinks = [] }: BreadcrumbStyle) {
  const pathname = usePathname();
  const segments = pathname ? pathname.split("/").filter(Boolean) : [];

  const breadcrumbList = segments.map((segment, index) => {
    const href = "/" + segments.slice(0, index + 1).join("/");
    const name = decodeURIComponent(segment)
      .replace(/-/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());

    return { name, href };
  });

  return (
    <section aria-label="Breadcrumb" className={className}>
      <ul className="flex items-center gap-1 text-xs sm:text-sm font-normal">
        <li className="flex items-center gap-1">
          <a href={ROOT_URL} className={parentText}>
            Home
          </a>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={separatorColor ? separatorColor : parentText}>
            <path d="M4.66602 12.083L8.74952 7.99952L4.66602 3.91602L5.91602 2.66602L11.2495 7.99952L5.91602 13.333L4.66602 12.083Z" fill="currentColor" />
          </svg>
        </li>

        {breadcrumbList.map((crumb, i) => {
          const isLast = i === breadcrumbList.length - 1;
          const isDisabled = disableCrumbLinks.includes(crumb.name.toLowerCase());

          return (
            <li key={crumb.href} className="flex items-center gap-1">
              {isLast ? (
                <span className={`${currentText} font-semibold line-clamp-1`}>{crumb.name}</span>
              ) : isDisabled ? (
                <span className={`${parentText} cursor-default line-clamp-1`}>{crumb.name}</span>
              ) : (
                <a href={crumb.href} className={parentText}>
                  {crumb.name}
                </a>
              )}
              {!isLast && (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={separatorColor ? separatorColor : parentText}>
                  <path d="M4.66602 12.083L8.74952 7.99952L4.66602 3.91602L5.91602 2.66602L11.2495 7.99952L5.91602 13.333L4.66602 12.083Z" fill="currentColor" />
                </svg>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
